<script>
    export let id;
    export let code;
    export let type;

    import { onMount } from 'svelte';
    import API from '../../api';

    export let enabled = false;

    let company = null;
    let companyLookup = false;
    let companyNotFound = false;

    export let form = {
        ico: '',
        dic: '',
        company: '',
        city: '',
        street: '',
        zip: ''
    };

    let isPerson = false;
    let formOpened = false;
    let lastIco = '';

    $: form.ico = checkNumber(form.ico);
    $: form.zip = checkNumber(form.zip);
    $: loadCompany(form.ico);

    function checkNumber(num) {
        num = num.toString();

        if (!num.length) return '';

        return num.replace(/[^\d]+/, '');
    }

    async function loadCompany(ico) {
        ico = ico.toString();

        // The last loaded one ?
        if (ico == lastIco) return;
        lastIco = ico;

        // Reset
        company = null;
        companyLookup = false;
        formOpened = false;
        companyNotFound = false;

        // Invalid ico
        if (ico.length !== 8) return;

        // Lookup start
        companyLookup = true;
        let res = await API.getCompany(ico);
        companyLookup = false;

        /// Show form
        formOpened = true;

        // Failed, show message
        if (!res || !res.status) {
            companyNotFound = true;
            return;
        }

        // Get company data
        company = {};
        let data = res.result;

        // Get only required company data
        for (let prop in form) {
            if (!form.hasOwnProperty(prop)) continue;

            company[prop] = data.hasOwnProperty(prop) ? data[prop] : '';
        }

        // Push to the form
        form = company;
    }

    function onPersonClick() {
        isPerson = !isPerson;

        if (isPerson) {
            form.ico = '';
        }
    }

    onMount(async () => {
        let res = await API.getInvoice(type, id, code);

        if (res) {
            form = company = res;
            enabled = true;

            if (!form.ico.length) {
                isPerson = true;
            }
        }
    });
</script>

<style>
    .main-form, .form:not(._show) {
        display: none;
    }

    .level {
        align-items: flex-end;
    }

    .level-left, .level-right {
        flex: 1;
    }

    .level-left {
        padding-right: 10px;
    }

    .level-right {
        padding-left: 10px;
    }

    .level-right._auto {
        flex: inherit;
    }

    .level-left .field, .level-right .field {
        width: 100%;
    }

    .panel {
        margin-top: 20px;
    }

    #inv_enable + label {
        cursor: pointer;
        display: block;
    }

    label i {
        margin-right: 5px;
    }

    #inv_enable:checked ~ .main-form {
        display: block;
    }

    .panel-block > small {
        display: block;
        margin-top: 15px;
        font-style: italic;
    }
</style>

<div class="panel is-info">
    <input class="is-hidden" type="checkbox" id="inv_enable" bind:checked={enabled}>
    <label class="panel-heading" for="inv_enable">
        <i class="fal" class:fa-check-circle={enabled} class:fa-circle={!enabled}></i> Vystavit fakturu
    </label>

    {#if enabled}
    <div class="panel-block main-form">
        <div class="level">
            <div class="level-left">
                <div class="field">
                    <label class="label" for="inv_ico">IČO</label>
                    <div class="control">
                        <input class="input" type="text" id="inv_ico" name="ico" bind:value={form.ico} maxlength="8" disabled={isPerson} required={!isPerson}>
                    </div>
                </div>
            </div>
            <div class="level-right _auto">
                <button type="button" class="button is-primary" on:click={onPersonClick}>
                    {#if isPerson}
                        Nejsem soukromá osoba
                    {:else}
                        Jsem soukromá osoba
                    {/if}
                </button>
            </div>
        </div>

        {#if companyLookup}
            <progress class="progress is-small is-primary"></progress>
        {:else if companyNotFound}
            <div class="notification is-warning">
                Při načítání dat ze systému ARES došlo k chybě, je nutné zadat údaje ručně.
            </div>
        {/if}

        <div class="form" class:_show={formOpened || isPerson}>
            <div class="level">
                <div class="level-left">
                    <div class="field">
                        <label class="label" for="inv_company">Jméno osoby / Název firmy</label>
                        <div class="control">
                            <input class="input" type="text" id="inv_company" name="company" bind:value={form.company} required>
                        </div>
                    </div>
                </div>

                <div class="level-right">
                    <div class="field">
                        <label class="label" for="inv_dic">DIČ</label>
                        <div class="control">
                            <input class="input" type="text" id="inv_dic" name="dic" bind:value={form.dic}>
                        </div>
                    </div>
                </div>
            </div>

            <div class="level">
                <div class="level-left">
                    <div class="field">
                        <label class="label" for="inv_street">Ulice a č. p.</label>
                        <div class="control">
                            <input class="input" type="text" id="inv_street" name="street" bind:value={form.street} required>
                        </div>
                    </div>
                </div>

                <div class="level-right">
                    <div class="field">
                        <label class="label" for="inv_city">Město</label>
                        <div class="control">
                            <input class="input" type="text" id="inv_city" name="city" bind:value={form.city} required>
                        </div>
                    </div>
                </div>
            </div>

            <div class="level">
                <div class="level-left">
                    <div class="field">
                        <label class="label" for="inv_zip">PSČ</label>
                        <div class="control">
                            <input class="input" type="text" id="inv_zip" name="zip" bind:value={form.zip} maxlength="6" required>
                        </div>
                    </div>
                </div>

                <div class="level-right">
                    <!-- <button class="button is-success">Vystavit fakturu</button> -->
                </div>
            </div>
        </div>

        <small>Faktura bude vystavena do 48 hodin od přijetí platby.</small>
    </div>
    {/if}
</div>

